<elder-basic-pane-layout class="full">
  <elder-pane class="flex-20">
    <elder-pane-header>
      <elder-pane-title>{{ 'transit.orders.title' | translate }}</elder-pane-title>
    </elder-pane-header>

    <elder-pane-content padding="0">
      <app-prod-order-transit-browser
        class="flex"
        [prodOrderId]="prodOrder?.id"
        (selectionSingleChange)="selected = $event"
      >
      </app-prod-order-transit-browser>
    </elder-pane-content>
  </elder-pane>

  @if (selected$ | async; as prodOrderTransit) {
    <app-prod-order-transit-detail
      class="flex"
      [prodOrderTransit]="prodOrderTransit"
      (transitAssignmentChange)="onTransitAssignmentChange($event)"
    >
    </app-prod-order-transit-detail>
  }
</elder-basic-pane-layout>
